import { render } from "./user_journey.html?vue&type=template&id=bdf6dc1e&external"
import script from "./user_journey.js?vue&type=script&lang=js&external"
export * from "./user_journey.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__